import { render, staticRenderFns } from "./ChatMain.vue?vue&type=template&id=52f50dae&scoped=true&"
import script from "./ChatMain.vue?vue&type=script&lang=js&"
export * from "./ChatMain.vue?vue&type=script&lang=js&"
import style0 from "./ChatMain.vue?vue&type=style&index=0&id=52f50dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f50dae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAvatar,VDivider,VIcon,VNavigationDrawer})
